import { Button, Checkbox, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRatewareControl extends Layout {
    buttonTestConnection: Button;
    buttonViewTariffs: Button;
    checkboxActive: Checkbox;
    checkboxIncludeSaturday: Checkbox;
    checkboxIncludeSunday: Checkbox;
    labelTransitDays: Label;
    panelActive: Panel;
    panelButtons: Panel;
    panelSmc3Control: Panel;
    panelTransitDays: Panel;
    sourceContractManagementControl: DataSource;
    textboxAccountNumber: Textbox;
    textboxAccountPassword: Textbox;
    textboxAccountUserId: Textbox;
    textboxEndpointUrl: Textbox;
    textboxRefSetting1: Textbox;
}
